import { Store } from '@ngrx/store';
import { AppState } from '../state/app.state';
import { loadCurrentUser } from '../state/current-user/current-user.actions';
import { selectCurrentUserRoles } from '../state/current-user/current-user.selectors';
import { filter, race, timer } from 'rxjs';
import { map, take } from 'rxjs/operators';
const INIT_ROLES_TIMEOUT_MS = 15_000;

export function initRoles(store: Store<AppState>): () => Promise<boolean> {
  return () =>
    new Promise<boolean>((resolve) => {
      store.dispatch(loadCurrentUser());

      const rolesLoaded$ = store.select(selectCurrentUserRoles).pipe(
        filter((roles) => roles?.length > 0),
        map(() => true),
        take(1)
      );

      const timeout$ = timer(INIT_ROLES_TIMEOUT_MS).pipe(
        map(() => {
          console.error(
            `initRoles: timed out after ${INIT_ROLES_TIMEOUT_MS}ms waiting for roles`
          );
          return false;
        })
      );

      race(rolesLoaded$, timeout$)
        .pipe(take(1))
        .subscribe((success) => resolve(success));
    });
}
